import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheckIcon, ClockIcon, StarIcon } from 'lucide-react';
import { BookingSearch } from './BookingSearch';
import type { TripSearch } from '../types/search';
interface HeroProps {
  onSearch: (search: TripSearch) => void;
}
export function Hero({
  onSearch
}: HeroProps) {
  return <section id="top" className="relative w-full overflow-hidden bg-ink" data-id="element-232" data-mp="4n9ymkjy9k48">
      <img src="https://cdn.magicpatterns.com/patterns/generated-images/bc05a389-a47d-495d-9146-3f3fde89fe43.jpg" alt="SUV driving on a scenic mountain highway" className="absolute inset-0 h-full w-full object-cover opacity-45" data-id="element-233" data-mp="129qrndlnhbk6" />
      <div className="absolute inset-0 bg-gradient-to-t from-ink via-ink/70 to-ink/30" data-id="element-234" data-mp="sd48ct8z2sk9" />

      <div className="relative mx-auto max-w-6xl px-4 pb-10 pt-16 sm:px-6 sm:pt-20" data-id="element-235" data-mp="neknkw647mth">
        <motion.div initial={{
        opacity: 0,
        y: 16
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.5
      }} className="max-w-2xl" data-id="element-236" data-mp="3d2tpxe128sgn">
          <span className="inline-flex items-center gap-2 rounded-full bg-white/10 px-3 py-1 text-xs font-semibold text-white ring-1 ring-white/20" data-id="element-237" data-mp="3j923tk0h7itf">
            <StarIcon className="h-3.5 w-3.5 text-accent" data-id="element-238" data-mp="39al8ybyf2k23" />
            Trusted car rentals across Nepal
          </span>
          <h1 className="mt-4 font-display text-4xl font-800 leading-tight text-white sm:text-5xl" data-id="element-239" data-mp="3e8mqgsg72bbg">
            Book a car with a driver, anytime you need to move.
          </h1>
          <p className="mt-4 max-w-xl text-base text-slate-200" data-id="element-240" data-mp="358hoixtrs54o">
            Airport transfers, destination trips and city tours — pick your car, choose day or
            night, and ride with confidence.
          </p>

          <div className="mt-6 flex flex-wrap gap-x-6 gap-y-2 text-sm text-slate-200" data-id="element-241" data-mp="2vi50uwqnrvub">
            <span className="flex items-center gap-2" data-id="element-242" data-mp="2hincujl6smm0">
              <ShieldCheckIcon className="h-4 w-4 text-brand-300" data-id="element-243" data-mp="2hl9rt4aeq4e9" /> Verified drivers
            </span>
            <span className="flex items-center gap-2" data-id="element-244" data-mp="2lmv3wnf4aene">
              <ClockIcon className="h-4 w-4 text-brand-300" data-id="element-245" data-mp="s333h94hagvf" /> 24/7 availability
            </span>
            <span className="flex items-center gap-2" data-id="element-246" data-mp="na9zwokqxekx">
              <StarIcon className="h-4 w-4 text-brand-300" data-id="element-247" data-mp="ic873bxiq0w9" /> Transparent pricing
            </span>
          </div>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 24
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.5,
        delay: 0.15
      }} className="mt-8" data-id="element-248" data-mp="ddwzl7up42h7">
          <BookingSearch onSearch={onSearch} data-id="element-249" data-mp="161jcx7tq6lh9" />
        </motion.div>
      </div>
    </section>;
}